var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateDesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "529px",
    height: "263px",
    viewBox: "0 0 529 263",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "publishing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    cx: 52,
    cy: 13,
    rx: 52,
    ry: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79830756,50.2235983 L12.1196891,50.3077383 C14.2911661,50.3273392 16.0503686,52.0759123 16.0831292,54.2472306 L16.1865735,61.1033441 C16.219901,63.3122317 14.456261,65.1299062 12.2473735,65.1632336 C12.229903,65.1634972 12.212431,65.1636463 12.1949586,65.163681 L2.79830756,65.1823096 L2.79830756,50.2235983 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 13.3887306,
    height: 14.9587113,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-MVP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-Products-Empty-State-2",
    transform: "translate(-246.000000, -439.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "publishing",
    transform: "translate(247.000000, 434.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.715047,151 L261.560242,151 C205.996872,164.057054 169.081788,172.588535 150.81499,176.594441 C132.548192,180.600347 104.846782,186.468867 67.7107586,194.2 L15.0710767,185.054446 L108.715047,151 Z",
    id: "shadow",
    fill: "#CBD8DC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mask",
    transform: "translate(0.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#949494",
    fill: "#FAFAFA",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#E8EFF1",
    mask: "url(#mask-2)",
    transform: "translate(86.663697, 15.130840) rotate(3.000000) translate(-86.663697, -15.130840) ",
    points: "82.2170409 -0.898159619 90.8873597 -0.828473977 91.1103537 31.1598394 82.440035 31.0901538"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(89.761851, 92.527223) rotate(120.000000) translate(-89.761851, -92.527223) translate(2.261851, 59.027223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3229074,24.8262449 L13.4304439,31.8056005 L27.3229074,38.7849561 L175.581546,38.7849561 L175.581546,24.8262449 L27.3229074,24.8262449 Z",
    id: "Rectangle-6",
    stroke: "#757575",
    fill: "#FAFAFA",
    transform: "translate(94.199099, 31.805601) scale(-1, 1) rotate(17.000000) translate(-94.199099, -31.805601) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.706432,11.7015397 L164.977642,9.32586985 L169.688397,6.95926023 C169.372005,7.40999133 169.236233,7.84959731 169.281079,8.27807818 C169.311812,8.57171251 169.739937,9.40275904 169.409568,10.0035441 C169.277135,10.2443761 169.37609,10.8103746 169.706432,11.7015397 Z",
    id: "Rectangle-6",
    fill: "#757575",
    transform: "translate(167.342037, 9.330400) scale(-1, 1) rotate(17.000000) translate(-167.342037, -9.330400) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4213799,27.6850286 L160.298555,27.6850286 L160.298555,32.2945453 L11.4213799,32.2945453 C11.9855908,31.2492847 12.2676963,30.4810319 12.2676963,29.989787 C12.2676963,29.498542 11.9855908,28.7302892 11.4213799,27.6850286 Z",
    id: "Rectangle-12",
    fill: "#E3DBBA",
    transform: "translate(85.859968, 29.989787) scale(-1, 1) rotate(17.000000) translate(-85.859968, -29.989787) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.34665,6.17525285 L156.374685,6.17525285 C156.837126,7.07936453 157.073435,7.85229708 157.083613,8.4940505 C157.093791,9.13580392 156.83138,9.89937694 156.296381,10.7847696 L155.384749,10.6842798 C155.923561,9.70601237 156.192966,8.97125619 156.192966,8.48001122 C156.192966,7.98876624 155.910861,7.22051345 155.34665,6.17525285 Z",
    id: "Rectangle-12",
    fill: "#757575",
    transform: "translate(156.215274, 8.480011) scale(-1, 1) rotate(17.000000) translate(-156.215274, -8.480011) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7690721,32.0931314 L161.646248,32.0931314 L161.646248,36.7026481 L12.7690721,36.7026481 C13.5531065,35.7893267 13.9451237,35.0939417 13.9451237,34.6164929 C13.9451237,34.1390441 13.5531065,33.2979236 12.7690721,32.0931314 Z",
    id: "Rectangle-12",
    fill: "#F3EFE0",
    transform: "translate(87.207660, 34.397890) scale(-1, 1) rotate(17.000000) translate(-87.207660, -34.397890) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1178748,36.4800846 L162.860781,36.5211349 L162.860781,40.2608127 L13.9836053,40.2608127 C14.4645211,39.6090523 14.704979,39.1098656 14.704979,38.7632525 C14.704979,38.4166395 14.5092776,37.6555835 14.1178748,36.4800846 Z",
    id: "Rectangle-12",
    fill: "#FFFFFF",
    transform: "translate(88.422193, 38.370449) scale(-1, 1) rotate(17.000000) translate(-88.422193, -38.370449) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.702924,10.543236 L157.730959,10.543236 C158.193399,11.4473477 158.429708,12.2202803 158.439886,12.8620337 C158.450065,13.5037871 158.187654,14.2673601 157.652655,15.1527527 L156.663096,15.3448015 C157.253859,14.1715084 157.54924,13.3392394 157.54924,12.8479944 C157.54924,12.3567494 157.267135,11.5884966 156.702924,10.543236 Z",
    id: "Rectangle-12",
    fill: "#757575",
    transform: "translate(157.551634, 12.944019) scale(-1, 1) rotate(17.000000) translate(-157.551634, -12.944019) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.367412,15.1620388 L159.338768,15.0055072 C159.801209,15.9096189 160.037518,16.6825514 160.047696,17.3243048 C160.057874,17.9660582 159.767656,18.7122689 159.177041,19.5629369 L158.289629,19.2895328 C158.867909,18.4612663 159.157049,17.8015105 159.157049,17.3102655 C159.157049,16.8190206 158.893837,16.102945 158.367412,15.1620388 Z",
    id: "Rectangle-12",
    fill: "#757575",
    transform: "translate(159.168792, 17.284222) scale(-1, 1) rotate(22.000000) translate(-159.168792, -17.284222) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-12",
    fill: "#757575",
    transform: "translate(86.501794, 32.089107) scale(-1, 1) rotate(17.000000) translate(-86.501794, -32.089107) ",
    points: "12.3700125 31.589107 160.940382 31.589107 160.940382 32.589107 12.3708816 32.589107 12.0632064 32.1040847"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-12",
    fill: "#757575",
    transform: "translate(87.963653, 36.741889) scale(-1, 1) rotate(17.000000) translate(-87.963653, -36.741889) ",
    points: "13.8318711 36.2418892 162.40224 36.2418892 162.40224 37.2418892 13.8327401 37.2418892 13.5250649 36.7568669"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-11",
    stroke: "#757575",
    mask: "url(#mask-4)",
    strokeWidth: 2,
    fill: "#F7EAF0",
    strokeDasharray: 1,
    transform: "translate(9.492673, 57.702954) scale(-1, 1) rotate(17.000000) translate(-9.492673, -57.702954) ",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    fill: "#757575",
    transform: "translate(20.343650, 54.385477) scale(-1, 1) rotate(17.000000) translate(-20.343650, -54.385477) ",
    x: 15.691238,
    y: 46.9061218,
    width: 9.30482347,
    height: 14.9587113
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    fill: "#ECECEC",
    transform: "translate(22.123299, 53.841384) scale(-1, 1) rotate(17.000000) translate(-22.123299, -53.841384) ",
    x: 21.1928168,
    y: 46.3620284,
    width: 1.86096469,
    height: 14.9587113
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    fill: "#ECECEC",
    transform: "translate(18.564000, 54.929571) scale(-1, 1) rotate(17.000000) translate(-18.564000, -54.929571) ",
    x: 17.633518,
    y: 47.4502152,
    width: 1.86096469,
    height: 14.9587113
  })), /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(73.575391, 88.981256) rotate(-63.000000) translate(-73.575391, -88.981256) translate(-7.424609, 57.481256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3229074,24.8262449 L0.430443857,31.8056005 L14.3229074,38.7849561 L162.581546,38.7849561 L162.581546,24.8262449 L14.3229074,24.8262449 Z",
    id: "Rectangle-6",
    stroke: "#757575",
    fill: "#FAFAFA",
    transform: "translate(81.199099, 31.805601) scale(-1, 1) rotate(17.000000) translate(-81.199099, -31.805601) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.706432,11.7015397 L151.977642,9.32586985 L156.688397,6.95926023 C156.372005,7.40999133 156.236233,7.84959731 156.281079,8.27807818 C156.311812,8.57171251 156.739937,9.40275904 156.409568,10.0035441 C156.277135,10.2443761 156.37609,10.8103746 156.706432,11.7015397 Z",
    id: "Rectangle-6",
    fill: "#757575",
    transform: "translate(154.342037, 9.330400) scale(-1, 1) rotate(17.000000) translate(-154.342037, -9.330400) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.57862012,27.6850286 L147.298555,27.6850286 L147.298555,32.2945453 L-1.57862012,32.2945453 C-1.01440918,31.2492847 -0.732303715,30.4810319 -0.732303715,29.989787 C-0.732303715,29.498542 -1.01440918,28.7302892 -1.57862012,27.6850286 Z",
    id: "Rectangle-12",
    fill: "#FFFFFF",
    transform: "translate(72.859968, 29.989787) scale(-1, 1) rotate(17.000000) translate(-72.859968, -29.989787) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.34665,6.17525285 L143.374685,6.17525285 C143.837126,7.07936453 144.073435,7.85229708 144.083613,8.4940505 C144.093791,9.13580392 143.83138,9.89937694 143.296381,10.7847696 L142.384749,10.6842798 C142.923561,9.70601237 143.192966,8.97125619 143.192966,8.48001122 C143.192966,7.98876624 142.910861,7.22051345 142.34665,6.17525285 Z",
    id: "Rectangle-12",
    fill: "#757575",
    transform: "translate(143.215274, 8.480011) scale(-1, 1) rotate(17.000000) translate(-143.215274, -8.480011) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.230927854,32.0931314 L148.646248,32.0931314 L148.646248,36.7026481 L-0.230927854,36.7026481 C0.553106506,35.7893267 0.945123686,35.0939417 0.945123686,34.6164929 C0.945123686,34.1390441 0.553106506,33.2979236 -0.230927854,32.0931314 Z",
    id: "Rectangle-12",
    fill: "#EEEADB",
    transform: "translate(74.207660, 34.397890) scale(-1, 1) rotate(17.000000) translate(-74.207660, -34.397890) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11787484,36.4800846 L149.860781,36.5211349 L149.860781,40.2608127 L0.983605292,40.2608127 C1.46452109,39.6090523 1.704979,39.1098656 1.704979,38.7632525 C1.704979,38.4166395 1.50927761,37.6555835 1.11787484,36.4800846 Z",
    id: "Rectangle-12",
    fill: "#E3DCBE",
    transform: "translate(75.422193, 38.370449) scale(-1, 1) rotate(17.000000) translate(-75.422193, -38.370449) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.702924,10.543236 L144.730959,10.543236 C145.193399,11.4473477 145.429708,12.2202803 145.439886,12.8620337 C145.450065,13.5037871 145.187654,14.2673601 144.652655,15.1527527 L143.663096,15.3448015 C144.253859,14.1715084 144.54924,13.3392394 144.54924,12.8479944 C144.54924,12.3567494 144.267135,11.5884966 143.702924,10.543236 Z",
    id: "Rectangle-12",
    fill: "#757575",
    transform: "translate(144.551634, 12.944019) scale(-1, 1) rotate(17.000000) translate(-144.551634, -12.944019) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.367412,15.1620388 L146.338768,15.0055072 C146.801209,15.9096189 147.037518,16.6825514 147.047696,17.3243048 C147.057874,17.9660582 146.767656,18.7122689 146.177041,19.5629369 L145.289629,19.2895328 C145.867909,18.4612663 146.157049,17.8015105 146.157049,17.3102655 C146.157049,16.8190206 145.893837,16.102945 145.367412,15.1620388 Z",
    id: "Rectangle-12",
    fill: "#757575",
    transform: "translate(146.168792, 17.284222) scale(-1, 1) rotate(22.000000) translate(-146.168792, -17.284222) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-12",
    fill: "#757575",
    transform: "translate(73.501794, 32.089107) scale(-1, 1) rotate(17.000000) translate(-73.501794, -32.089107) ",
    points: "-0.629987453 31.589107 147.940382 31.589107 147.940382 32.589107 -0.629118377 32.589107 -0.936793578 32.1040847"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-12",
    fill: "#757575",
    transform: "translate(74.963653, 36.741889) scale(-1, 1) rotate(17.000000) translate(-74.963653, -36.741889) ",
    points: "0.831871071 36.2418892 149.40224 36.2418892 149.40224 37.2418892 0.832740147 37.2418892 0.525064946 36.7568669"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.386540362,67.9519056 C2.33156678,74.6871736 24.7523825,80 52.1247948,80 C79.4966161,80 101.917055,74.687403 103.862923,67.9523417 C103.863664,67.9681348 103.864039,67.9840236 103.864039,68 C103.864039,68.0423927 103.861343,68.0847425 103.855968,68.126793 L89.1782808,182.953502 C89.1784354,182.968995 89.1785128,182.984494 89.1785128,183 C89.1785128,190.179702 72.5889982,196 52.1247948,196 C31.6605914,196 15.0710767,190.179702 15.0710767,183 C15.0710767,182.984494 15.0711541,182.968995 15.0713087,182.953502 L0.393621496,68.126793 C0.386079796,68.0677927 0.383843034,68.009337 0.386540362,67.9519056 Z",
    id: "front-cup",
    stroke: "#949494",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1315728,83.9833104 C19.6441733,88.1771221 35.5886363,91 53.8539683,91 C79.8984096,91 101.224116,85.2605927 103.013833,77.9911019 C103.094427,78.3243124 103.135413,78.660747 103.135413,79 C103.135413,86.7319865 81.8455361,93 55.5831418,93 C35.282744,93 17.9534427,89.2548399 11.1315796,83.9833157 Z",
    id: "shading",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("g", {
    id: "paper",
    transform: "translate(43.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.73937015,55.3165263 C8.43684732,53.2914542 39.3053828,54.0124084 51.4540605,52.7944158 C59.553179,51.9824208 121.62212,39.4117704 237.660884,15.0824648 C397.579933,65.965659 478.013794,91.8380261 478.962467,92.6995662 C480.385475,93.9918762 478.435848,94.7186527 478.641433,94.897283 C480.187347,96.2405106 478.692591,97.0688841 474.157165,97.3824036 C481.184125,99.2664984 484.308702,100.806096 483.530896,102.001197 C482.753091,103.196297 414.501024,117.895185 278.774695,146.09786 C241.479296,134.133879 220.575973,127.211075 216.064726,125.32945 C211.929581,124.057039 91.9083548,91.6938967 50.1472555,77.7297404 C23.1837311,68.7136256 2.90717091,57.1586625 3.73937015,55.3165263 Z",
    id: "shadow",
    fill: "#CBD8DC",
    transform: "translate(243.680910, 80.590163) scale(-1, 1) rotate(-3.000000) translate(-243.680910, -80.590163) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.531121,143.665316 L453.425018,94.2328334 C453.594023,94.1908294 453.728998,94.0639167 453.781319,93.8978156 C453.864283,93.6344308 453.718023,93.3536595 453.454638,93.2706952 L197.326355,12.5922032 C100.957153,39.7915719 48.8117986,53.7731849 40.6695476,54.5895042 C32.8756865,55.370895 22.2639551,55.9427853 8.83167265,56.3056708 C8.7482523,56.3079245 8.66672254,56.3310209 8.59451481,56.3728549 C8.35556704,56.5112906 8.27409058,56.8172122 8.41253971,57.056161 C12.658402,64.3847576 16.7646845,69.2815596 20.7095614,71.7471004 C24.9597213,74.4034425 31.9748504,77.5316578 41.7125682,81.1124344 L254.531121,143.665316 Z",
    id: "paper3",
    stroke: "#949494",
    fill: "#ECECEC",
    transform: "translate(231.074837, 78.126852) scale(-1, 1) rotate(-3.000000) translate(-231.074837, -78.126852) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.263611,10.5108147 C98.8936223,37.7104119 46.7478582,51.6921405 38.6055725,52.5084634 C30.8098562,53.2900402 20.7348285,52.456935 8.37319421,50.0136908 C8.28229977,49.9957258 8.18820116,50.0033714 8.1013992,50.0357745 C7.84270806,50.1323437 7.71127421,50.4203489 7.8078258,50.6790356 C11.2234956,59.8289879 16.2553179,66.531782 22.9026034,70.8046017 C30.0031476,75.3687723 38.6009581,79.0337774 48.711193,81.801463 L222.535055,134.933671 C226.609983,135.949446 230.921511,137.007137 235.46963,138.10674 C239.780593,139.149005 242.080897,138.862952 242.5056,137.495491 L242.657677,137.005835 L243.143356,137.170169 C247.694043,138.709938 252.915543,139.558084 258.808398,139.712394 C264.681137,139.866177 269.887343,138.988715 274.495715,137.061188 L449.988978,90.3992641 C450.155287,90.3550441 450.287169,90.2284074 450.338099,90.0640287 C450.419823,89.8002566 450.272244,89.5201763 450.008472,89.4384517 L195.263611,10.5108147 Z",
    id: "paper2",
    stroke: "#949494",
    fill: "#F6F6F6",
    transform: "translate(229.068387, 75.109504) scale(-1, 1) rotate(-1.500000) translate(-229.068387, -75.109504) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.714201,132.610753 C229.043225,134.341808 224.071038,135.209319 218.800397,135.213692 C213.43337,135.218145 207.828174,134.327604 201.980714,132.542149 L43.6575279,82.4276635 C36.9859354,81.2644202 29.4404213,76.569302 20.9997106,68.3583986 C12.8219745,60.4033101 7.22164025,52.8926026 4.20250947,45.8183226 C4.04014648,45.4374115 4.2171569,44.9969345 4.59803485,44.834385 C4.79917086,44.7485451 5.02775612,44.754777 5.22391627,44.8514486 C13.1370458,48.7511927 20.9918931,50.3065909 28.7973544,49.5240371 C40.1375561,48.3871 96.0829495,34.899646 164.132795,15.7836945 C168.922392,14.4382439 176.000988,11.6907218 185.359156,7.54288865 L185.53219,7.46619446 L442.712928,88.8647138 C443.107834,88.9897028 443.326645,89.4111608 443.201656,89.8060667 C443.124357,90.0502945 442.927752,90.2381772 442.68027,90.3043215 L268.907354,136.748251 C266.352877,137.515729 261.303315,138.2314 253.729008,138.904531 C246.152927,139.57782 239.471524,137.476899 233.714201,132.610753 Z",
    id: "paper1",
    stroke: "#949494",
    fill: "#FFFFFF",
    transform: "translate(223.689542, 73.263558) scale(-1, 1) translate(-223.689542, -73.263558) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateDesk);
export default __webpack_public_path__ + "static/media/EmptyStateDesk.c65814182b3e29104534afdc8f59d127.svg";
export { ForwardRef as ReactComponent };